import { ISJArapport } from "./reportSchemas/sjaSchema";

const ELEKTRO_INIT_DATA = {
  generell: {
    name: "Generell",
    isSelected: true,
    faremomenter: [
      {
        isSelected: true,
        deloppgave: "Inspeksjon av elektriske installasjoner (lys, stikk, o.l, inkludert målinger)",
        faremoment: "Strømgjennomgang, dårlig belysning, fall, uoppmerksomhet",
        tiltak: "Nødvendig verneutstyr, oppmerksomhet",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Statisk elektrisitet",
        faremoment: "Elektrisk sjokk, brann, ødeleggelse av utstyr",
        tiltak: "Bruk av antistatisk utstyr, sikre området før inspeksjon",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Termografering",
        faremoment: "Strømgjennomgang",
        tiltak: "Bruk av verneutstyr, sikre området før inspeksjon",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Idriftsettelse (f.eks UPS, reservekraft, brann, nødlys o.l.)",
        faremoment: "Strømgjennomgang, eksplosjon, lysbue",
        tiltak:
          "Bruk av verneutstyr, sikre området før idriftsettelse, kun nødvendige personell til stede ved oppstart av utstyr",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Inspeksjon av basseng og svømmeanlegg",
        faremoment: "Fall, drukning",
        tiltak: "Oppmerksomhet i hvor man går, bevissthet rundt glatte områder",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Trange omgivelser",
        faremoment: "Panikk, sår/rifter",
        tiltak: "Avklare klaustrofobiske følelser på forhånd, vurdering av bekledning",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Tett møblert arealer med verdifulle/vernede objekter (eks. museum, laboratorium)",
        faremoment: "Ødeleggelse/skader av objekter",
        tiltak: "Vurdering av bekledning, ikke ha med sekker/vesker, forsiktige bevegelser",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
    ],
  },
  tekniskRom: {
    name: "Teknisk rom",
    isSelected: true,
    faremomenter: [
      {
        isSelected: true,
        deloppgave: "Kontroll av hovedfordeling, underfordeling, automatikkfordeling",
        faremoment: "Strømgjennomgang, lysbue",
        tiltak: "Bruk av verneutstyr, sikre området før inspeksjon",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Inspeksjon av maskinrom med roterende deler",
        faremoment: "Klemfare, kuttskader",
        tiltak: "Bruk av verneutstyr, sikre maskiner før inspeksjon",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
    ],
  },
  ute: {
    name: "Ute",
    isSelected: true,
    faremomenter: [
      {
        isSelected: true,
        deloppgave: "Befaring ute",
        faremoment: "Dårlig vær, dyreangrep",
        tiltak: "Sjekk værmelding, om meldt lynvær skal ny dato for befaring fastsettes",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Utendørsinstallasjoner (f.eks byggegrop, kummer)",
        faremoment: "Fall, fallende/spisse gjenstander, sprøyter",
        tiltak: "Avklare HMS-regime på plassen, bruk av verneutstyr, sikre området før inspeksjon",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Vei- og jernbanebefaringer",
        faremoment: "Trafikkulykker, fall",
        tiltak: "Avklare HMS-regime på plassen, bruk av verneutstyr, sikre området før inspeksjon",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Inspeksjon på tak",
        faremoment: "Fall fra høyde",
        tiltak:
          "Bruk av fallsikringsutstyr, sikre at taket er stabilt, holde seg minimumn to meter fra kant og taket skal ikke ha vinkel (flatt tak)",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Tilkomst tak",
        faremoment: "Fall fra høyde",
        tiltak: "Adkomstveier skal være ihht. regler og krav (f.eks ref. §17 i forskrift om utførelse av arbeid)",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
    ],
  },
  spesial: {
    name: "Spesial",
    isSelected: true,
    faremomenter: [
      {
        isSelected: true,
        deloppgave: "Inspeksjon av EX-områder",
        faremoment: "Eksplosjon, brann",
        tiltak: "Avklare rutiner på plassen, bruk av EX-godkjent utstyr",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Inspeksjon av nettstasjoner",
        faremoment: "Strømgjennomgang, eksplosjon",
        tiltak: "Bruk av verneutstyr, sikre området før inspeksjon",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Inspeksjon av maritime anlegg",
        faremoment: "Fall, drukning, fallende gjenstander",
        tiltak: "Bruk av verneutstyr, sikre området før inspeksjon",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Inspeksjon av kjemiske/biologiske/radioaktive områder",
        faremoment: "Eksponering for farlige stoffer/stråling",
        tiltak: "Bruk av verneutstyr, sikre god ventilasjon, tidsbegrenset opphold, gjør måling før befaring",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Inspeksjon av radonutsatte områder",
        faremoment: "Eksponering for radon",
        tiltak: "Bruk av verneutstyr, sikre god ventilasjon, tidsbegrenset opphold, gjør måling før befaring",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Inspeksjon av asbestutsatte områder",
        faremoment: "Eksponering for asbest",
        tiltak: "Bruk av verneutstyr, sikre området før inspeksjon",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
      {
        isSelected: true,
        deloppgave: "Inspeksjon av smelteverk",
        faremoment: "Høy varme, brann",
        tiltak: "Bruk av verneutstyr, sikre området før inspeksjon",
        restrisiko: "",
        ansvarlig: "",
        kommentar: "",
      },
    ],
  },
};

export const SJA_INIT_DATA: ISJArapport = {
  generellInfo: {
    sjaTittel: "",
    oppdragsNavn: "",
    oppdragsNummer: "",
    firmaAvdelingSeksjon: "",
    beskrivelseAvArbeidet: "",
    forutsetninger: "",
    sjaKoordinator: "",
    jobbOperasjon: "",
    dato: "",
  },
  deltagere: [
    {
      navn: "",
      avdSeksjon: "",
    },
    {
      navn: "",
      avdSeksjon: "",
    },
    {
      navn: "",
      avdSeksjon: "",
    },
    {
      navn: "",
      avdSeksjon: "",
    },
    {
      navn: "",
      avdSeksjon: "",
    },
  ],
  selectedReport: null,
  options: ELEKTRO_INIT_DATA,
};
